export const readHiddenInputs = (form: HTMLFormElement) => {
	const hiddenInputs = form.querySelectorAll('input[type="hidden"]') as NodeListOf<HTMLInputElement>;
	return Array.from(hiddenInputs).reduce((acc, input) => ({ ...acc, [input.name]: input.value }), {});
};
